var map = {
	"./bs_shere-pinky-hanger_.png": 572646,
	"./bs_shere-pinky-hanger_blk.png": 895177,
	"./bs_shere-pinky-hanger_blu.png": 622999,
	"./bs_shere-pinky-hanger_cho 2.png": 930730,
	"./bs_shere-pinky-hanger_cho.png": 224880,
	"./bs_shere-pinky-hanger_cml.png": 823004,
	"./bs_shere-pinky-hanger_crk.png": 91082,
	"./bs_shere-pinky-hanger_dor.png": 164515,
	"./bs_shere-pinky-hanger_gld.png": 61115,
	"./bs_shere-pinky-hanger_grn.png": 863371,
	"./bs_shere-pinky-hanger_gry.png": 109060,
	"./bs_shere-pinky-hanger_lmn.png": 469953,
	"./bs_shere-pinky-hanger_mgn.png": 623662,
	"./bs_shere-pinky-hanger_nvy.png": 57237,
	"./bs_shere-pinky-hanger_orn.png": 723651,
	"./bs_shere-pinky-hanger_pnk.png": 603025,
	"./bs_shere-pinky-hanger_ppl.png": 296592,
	"./bs_shere-pinky-hanger_red.png": 459033,
	"./bs_shere-pinky-hanger_sax.png": 244764,
	"./bs_shere-pinky-hanger_sil.png": 444528,
	"./bs_shere-pinky-hanger_wht.png": 592295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 573317;